/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.LogisticsQuotationResponseDto>>;
export function request(
  params: API.tms.logisticsQuotation.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
